import { render, staticRenderFns } from "./Authorization.vue?vue&type=template&id=b849933a&"
import script from "./Authorization.vue?vue&type=script&lang=js&"
export * from "./Authorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports